/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ExternalVoucherStatus {
  PENDING_VERIFICATION = 'pending_verification',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
}
